import Image from 'next/image'
import clsx from 'clsx'

import { Text } from '@wartek-id/text-v1'

import { assetUrl } from 'utils/url'

import type { FC } from 'react'

type EvaluationResultHeaderProps = {
  title: string
  period: number
}

/**
 * Renders the header component for the evaluation result.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {string} props.title - The title of the evaluation result.
 * @param {number} props.period - The period of the evaluation result. 1 for Semester 1, 2 for Semester 2, and 3 for Yearly.
 * @returns {JSX.Element} The rendered header component.
 */
const EvaluationResultHeader: FC<EvaluationResultHeaderProps> = ({
  title,
  period,
}) => {
  return (
    <>
      <section
        className={clsx(
          'flex flex-row items-center gap-6 py-6 px-9 rounded-t-lg',
          {
            'bg-purple-20': period === 1,
            'bg-teal-20': period === 2,
            '!bg-[linear-gradient(91.11deg,_#103178_48.06%,_#2560E0_137.64%)] relative overflow-hidden':
              period === 3,
          }
        )}
      >
        {period === 3 && (
          <img
            alt=""
            role="presentation"
            src={assetUrl('/images/pengelolaan-kinerja/confetti.png')}
            className="absolute right-0 top-0"
            width={144}
          />
        )}

        <div className="flex flex-row gap-3 flex-none h-11 items-center">
          <Image
            alt="Logo Tut Wuri Handayani"
            src="/images/kemendikbud2x.png"
            width={40}
            height={40}
            className="select-none pointer-events-none"
          />

          <img
            src={assetUrl(
              period === 3
                ? '/icon/e-pengelolaan-kinerja-logo-secondary.png'
                : '/icon/e-pengelolaan-kinerja-logo.png'
            )}
            width={124}
            height={32}
            alt=""
            className="flex-shrink-0 select-none pointer-events-none w-auto h-8"
          />
        </div>

        <div className="flex-1">
          <Text
            as="span"
            variant="heading-lg"
            className="select-none pointer-events-none"
            color={period === 3 ? 'inverse' : 'default'}
          >
            {title}
          </Text>
        </div>
      </section>
    </>
  )
}
export default EvaluationResultHeader
